"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPANY_ID_MAP = void 0;
var COMPANY_ID_MAP;
(function (COMPANY_ID_MAP) {
    COMPANY_ID_MAP[COMPANY_ID_MAP["DINAMICA"] = 7] = "DINAMICA";
})(COMPANY_ID_MAP || (exports.COMPANY_ID_MAP = COMPANY_ID_MAP = {}));
